import styled from "@emotion/styled";
import {Permissions} from "api/auth";
import {DropDown} from "components/DropDown";
import Loading from "components/Loading";
import {H2} from "components/elements";
import {useEffect, useState} from "react";
import NewQuote from ".";
import {useAuth, usePermissions} from "hooks/auth";
import Button from "components/Button";
import {useHistory} from "react-router-dom";
import {TextInput} from "components/TextInput";

const StyledDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 10vh 30vw 10vh;
`;

const StyledButtons = styled.div`
  display: flex;
  margin-top: 15px;
  gap: 7px;
`;

export default function HabStateCheck() {
  const states = ["NJ", "NY"];
  const permissons = usePermissions();
  const {assignedStates} = useAuth();
  const history = useHistory();

  const [stateSelected, setStateSelected] = useState("");
  const [effectiveDateSelected, setEffectiveDateSelected] = useState("");

  const [proceedSelected, setProceedSelected] = useState(false);
  const onlyNJ = assignedStates.length === 1 && assignedStates[0] === "NJ";

  const [NJSelected, setNJSelected] = useState(false);
  const [otherThanNJSelected, setOtherThanNJSelected] = useState(false);

  useEffect(() => {
    if (otherThanNJSelected) {
      process.env.REACT_APP_NEW_HABITATIONAL_QUOTE_LINK
        ? (window.location.href =
            process.env.REACT_APP_NEW_HABITATIONAL_QUOTE_LINK)
        : window.location.reload();
    }
  }, [otherThanNJSelected]);
  if (!permissons.includes(Permissions.CREATE_MAJESCO_NY_QUOTE)) {
    return permissons.includes(Permissions.CAN_QUOTE_MAJESCO_ALL_STATES) ||
      onlyNJ ||
      NJSelected ? (
      <NewQuote quoteType={"HAB"} />
    ) : otherThanNJSelected ? (
      <Loading>
        <H2>Just a sec while we redirect you...</H2>
      </Loading>
    ) : (
      <StyledDiv>
        <H2>What state is the risk located in?</H2>
        <DropDown
          label={"Select a state"}
          value={"selectedAgencyId"}
          options={assignedStates.map((state) => ({
            title: state,
            value: state,
          }))}
          onChange={(value) => {
            if (value === "NJ") {
              setNJSelected(true);
              setOtherThanNJSelected(false);
            } else {
              setOtherThanNJSelected(true);
              setNJSelected(false);
            }
          }}
        />
      </StyledDiv>
    );
  } else {
    return !stateSelected ? (
      <StyledDiv>
        <H2>What state is the risk located in?</H2>
        <DropDown
          label={"Select a state"}
          value={"selectedAgencyId"}
          options={states.map((state) => ({
            title: state,
            value: state,
          }))}
          onChange={(value) => {
            if (value === "NJ") {
              setStateSelected("NJ");
            } else if (value === "NY") {
              setStateSelected("NY");
            }
          }}
        />
      </StyledDiv>
    ) : stateSelected === "NJ" && !proceedSelected ? (
      <>
        <StyledDiv>
          <H2>What state is the risk located in?</H2>
          <DropDown
            label={"Select a state"}
            value={stateSelected}
            options={states.map((state) => ({
              title: state,
              value: state,
            }))}
            onChange={(value) => {
              if (value === "NJ") {
                setStateSelected("NJ");
              } else if (value === "NY") {
                setStateSelected("NY");
              }
            }}
          />

          <StyledButtons>
            <Button onClick={() => history.push("/")}>Back</Button>
            <Button onClick={() => setProceedSelected(true)}>Proceed</Button>
          </StyledButtons>
        </StyledDiv>
      </>
    ) : stateSelected === "NJ" && proceedSelected ? (
      <NewQuote quoteType={"HAB"} />
    ) : stateSelected === "NY" && !effectiveDateSelected ? (
      <StyledDiv>
        <H2>What state is the risk located in?</H2>
        <DropDown
          label={"Select a state"}
          value={stateSelected}
          options={states.map((state) => ({
            title: state,
            value: state,
          }))}
          onChange={(value) => {
            if (value === "NJ") {
              setStateSelected("NJ");
            } else if (value === "NY") {
              setStateSelected("NY");
            }
          }}
        />
        <H2>What is the effective date for this risk?</H2>
        <div>
          <TextInput
            type="date"
            background
            required={true}
            value={effectiveDateSelected}
            onChange={(e) => {
              setEffectiveDateSelected((e.target as HTMLInputElement).value);
            }}
          />
        </div>
      </StyledDiv>
    ) : stateSelected === "NY" && effectiveDateSelected < "2024-06-01" ? (
      <StyledDiv>
        <H2>What state is the risk located in?</H2>
        <DropDown
          label={"Select a state"}
          value={stateSelected}
          options={states.map((state) => ({
            title: state,
            value: state,
          }))}
          onChange={(value) => {
            if (value === "NJ") {
              setStateSelected("NJ");
            } else if (value === "NY") {
              setStateSelected("NY");
            }
          }}
        />
        <H2>What is the effective date for this risk?</H2>
        <div>
          <TextInput
            type="date"
            background
            value={effectiveDateSelected}
            required={true}
            onChange={(e) => {
              setEffectiveDateSelected((e.target as HTMLInputElement).value);
            }}
          />
        </div>
        <h4>
          Please note, you will be redirected to our legacy portal. Risks with
          effective dates post 6/1/2024 are not eligible for quote on the legacy
          portal. If after entering a risk with an effective date prior to
          6/1/2024, you choose to change the effective date to after 6/1/202,
          you will need to re-enter it on the new portal, to receive an updated
          quote.”
        </h4>
        <StyledButtons>
          <Button onClick={() => history.push("/")}>Back</Button>
          <Button
            onClick={() =>
              process.env.REACT_APP_NEW_HABITATIONAL_QUOTE_LINK
                ? (window.location.href =
                    process.env.REACT_APP_NEW_HABITATIONAL_QUOTE_LINK)
                : window.location.reload()
            }
          >
            Proceed
          </Button>
        </StyledButtons>
      </StyledDiv>
    ) : stateSelected === "NY" &&
      effectiveDateSelected >= "2024-06-01" &&
      !proceedSelected ? (
      <div>
        <StyledDiv>
          <H2>What state is the risk located in?</H2>
          <DropDown
            label={"Select a state"}
            value={stateSelected}
            options={states.map((state) => ({
              title: state,
              value: state,
            }))}
            onChange={(value) => {
              if (value === "NJ") {
                setStateSelected("NJ");
              } else if (value === "NY") {
                setStateSelected("NY");
              }
            }}
          />
          <H2>What is the effective date for this risk?</H2>
          <div>
            <TextInput
              type="date"
              background
              required={true}
              value={effectiveDateSelected}
              onChange={(e) => {
                setEffectiveDateSelected((e.target as HTMLInputElement).value);
              }}
            />
          </div>
          <StyledButtons>
            <Button onClick={() => history.push("/")}>Back</Button>
            <Button onClick={() => setProceedSelected(true)}>Proceed</Button>
          </StyledButtons>
        </StyledDiv>
      </div>
    ) : stateSelected === "NY" &&
      effectiveDateSelected >= "2024-06-01" &&
      proceedSelected ? (
      <NewQuote quoteType={"HAB"} />
    ) : (
      <div></div>
    );
  }
}
